"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _FormControl = require("react-bootstrap/lib/FormControl");

var _FormControl2 = _interopRequireDefault(_FormControl);

var _InputWrapper = require("../internal/InputWrapper");

var _InputWrapper2 = _interopRequireDefault(_InputWrapper);

var _IconKeyboardArrowDown = require("../Icons/IconKeyboardArrowDown");

var _IconKeyboardArrowDown2 = _interopRequireDefault(_IconKeyboardArrowDown);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Fields that reveal lists of choices when engaged
 */
var SelectInput = function (_React$Component) {
  _inherits(SelectInput, _React$Component);

  function SelectInput() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, SelectInput);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = SelectInput.__proto__ || Object.getPrototypeOf(SelectInput)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      repressError: true
    }, _this.getError = function (label, value, errorFromParent) {
      var required = _this.props.required;
      var repressError = _this.state.repressError;

      if (errorFromParent) {
        return errorFromParent;
      } else if (repressError) {
        return "";
      } else if (!value && required) {
        return label ? label + " is required" : "Field is required";
      }
      return "";
    }, _this.getValidationState = function (error, warning) {
      if (warning) {
        return "warning";
      } else if (error) {
        return "error";
      }
      return null;
    }, _this.onChange = function (event) {
      var value = event.target.value;
      var _this$props = _this.props,
          error = _this$props.error,
          label = _this$props.label,
          name = _this$props.name,
          onChange = _this$props.onChange;

      var isValid = !_this.getError(label, value, error);
      onChange({ target: { name: name, value: value } }, isValid, event);
    }, _this.onBlur = function (event) {
      _this.setState({
        repressError: false
      });
      if (_this.props.onBlur) _this.props.onBlur(event);
    }, _this.getFormControl = function () {
      var _this$props2 = _this.props,
          disabled = _this$props2.disabled,
          displayPlaceholder = _this$props2.displayPlaceholder,
          htmlId = _this$props2.htmlId,
          name = _this$props2.name,
          options = _this$props2.options,
          placeholder = _this$props2.placeholder,
          readOnly = _this$props2.readOnly,
          value = _this$props2.value;

      return _react2.default.createElement(
        "div",
        { className: "select-wrapper" },
        _react2.default.createElement(
          _FormControl2.default,
          Object.assign({
            className: "selectInput",
            id: htmlId,
            componentClass: "select",
            onBlur: _this.onBlur,
            onChange: _this.onChange
          }, {
            disabled: disabled,
            name: name,
            placeholder: placeholder,
            readOnly: readOnly,
            value: value
          }),
          displayPlaceholder && _react2.default.createElement(
            "option",
            { value: "" },
            placeholder
          ),
          options.map(function (_ref2, key) {
            var value = _ref2.value,
                label = _ref2.label;

            return _react2.default.createElement(
              "option",
              { id: "selectInput-" + key, key: value, value: value },
              label ? label : value
            );
          })
        ),
        _react2.default.createElement(_IconKeyboardArrowDown2.default, {
          htmlId: htmlId + "-dropdown-icon",
          className: "select-dropdown-icon " + (disabled ? "disabled" : readOnly ? "readonly" : "")
        })
      );
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }
  // Repress any initial errors unless passed in with error prop, after interaction repressError is set to false.


  _createClass(SelectInput, [{
    key: "render",
    value: function render() {
      var _props = this.props,
          className = _props.className,
          htmlId = _props.htmlId,
          label = _props.label,
          layout = _props.layout,
          value = _props.value,
          warning = _props.warning,
          props = _objectWithoutProperties(_props, ["className", "htmlId", "label", "layout", "value", "warning"]);

      var error = this.getError(label, value, this.props.error);
      var validationState = this.getValidationState(error, warning);
      var helpBlockMessage = validationState === "warning" ? warning : validationState === "error" ? error : null;

      var formControl = this.getFormControl();
      var containerClass = (className ? " " + className : "") + (layout === "horizontal" ? " input-side-by-side" : "");
      return _react2.default.createElement(_InputWrapper2.default, Object.assign({
        className: "cx-select" + containerClass
      }, Object.assign({
        htmlId: htmlId,
        label: label,
        helpBlockMessage: helpBlockMessage,
        formControl: formControl,
        validationState: validationState
      }, props)));
    }
  }]);

  return SelectInput;
}(_react2.default.Component);

SelectInput.propTypes = {
  /** Any children to be passed through. */
  children: _propTypes2.default.node,

  /** Appended to the FormGroup. */
  className: _propTypes2.default.string,

  /** Set to true to disable the SelectInput along with any included addons. */
  disabled: _propTypes2.default.bool,

  /** Displays label if set to true. */
  displayLabel: _propTypes2.default.bool,

  /** Hides placeholder if set to false. */
  displayPlaceholder: _propTypes2.default.bool,

  /** String to display when error occurs. */
  error: _propTypes2.default.string,

  /** Globally unique, descriptive ID. Used for automated testing. */
  htmlId: _propTypes2.default.string.isRequired,

  /** Label text that shows above the select box. */
  label: _propTypes2.default.string,

  /** Set the input layout style. Either `vertical` or `horizontal`. */
  layout: _propTypes2.default.oneOf(["vertical", "horizontal"]),

  /** Sets max height of menu dropdown in pixels. */
  maxHeight: _propTypes2.default.number,

  /** FormControl name. */
  name: _propTypes2.default.string.isRequired,

  /** onBlur callback. */
  onBlur: _propTypes2.default.func,

  /** onChange callback. Called with `cb(cxEvent, isValid, domEvent)`.
   * Open the console to view returned data from fired onChange event.
   *
   * - cxEvent: Returns component specific data whose shape is `{target: {name, value}}`.
   * - isValid: Boolean that specifies if the control is in error.
   * - domEvent: The unaltered event returned from the input's interaction, if exists.
   */
  onChange: _propTypes2.default.func.isRequired,

  /** An array of options as key value pairs: `[{value:'1', label:'option 1'}]` or values: `[{value:'1'}]`. */
  options: _propTypes2.default.array.isRequired,

  /** Select box placeholder text that is displayed when no value is selected. Defaults to Select + label if empty. */
  placeholder: _propTypes2.default.string,

  /** Set to true to make the control readonly. This will disable the input but not included addons.
   * Use the `disabled` prop instead if you need both the input and its addons disabled.*/
  readOnly: _propTypes2.default.bool,

  /** Perform validation on blur and mark field as required with asterisk if true. */
  required: _propTypes2.default.bool,

  /** The value of the selected item. */
  value: _propTypes2.default.string
};

SelectInput.defaultProps = {
  displayLabel: true,
  displayPlaceholder: true,
  layout: "vertical",
  readOnly: false
};

SelectInput.Addon = _InputWrapper2.default.Addon;

exports.default = SelectInput;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@cx/ui/SelectInput/SelectInput.js
// module id = 584
// module chunks = 0